import {
	CreateMediaRoomRequest,
	CreateMediaRoomResponse,
	GetActiveMediaRoomsResponse,
	IssueJoinTokenRequest,
	IssueJoinTokenResponse,
} from "@somewear/api";
import { grpc, someGrpc } from "@somewear/grpc";
import {
	ActionSetEpic,
	createActionSetEpicHandler,
	createMergingActionSetEpicHandler,
} from "@somewear/model";
import { combineEpics } from "redux-observable";

import { mediaCommRoomActions } from "./mediaComms.rooms.actions";

const getMediaRoomJoinTokenEpic: ActionSetEpic<
	IssueJoinTokenRequest.AsObject,
	IssueJoinTokenResponse.AsObject
> = (action$, state$) =>
	createMergingActionSetEpicHandler(
		action$,
		state$,
		mediaCommRoomActions.getMediaRoomJoinToken,
		(payload) => grpc.prepareRequestWithPayload(someGrpc.issueWebRtcJoinToken, payload.data),
	);

const createMediaRoomEpic: ActionSetEpic<
	CreateMediaRoomRequest.AsObject,
	CreateMediaRoomResponse.AsObject
> = (action$, state$) =>
	createActionSetEpicHandler(action$, state$, mediaCommRoomActions.createMediaRoom, (payload) =>
		grpc.prepareRequestWithPayload(someGrpc.createMediaRoom, payload.data),
	);

const getActiveMediaRoomsEpic: ActionSetEpic<void, GetActiveMediaRoomsResponse.AsObject> = (
	action$,
	state$,
) =>
	createActionSetEpicHandler(action$, state$, mediaCommRoomActions.getActiveMediaRooms, () =>
		grpc.prepareRequest(someGrpc.getActiveMediaCommRooms),
	);

export const mediaCommsRoomEpics = combineEpics<any, any, any>(
	getMediaRoomJoinTokenEpic,
	createMediaRoomEpic,
	getActiveMediaRoomsEpic,
);
